/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect } from "react";

import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { navigation } from "@origin-digital/reporting-client";

import { Screen, YupForm } from "@/components";
import { appName } from "@/config";
import { TRANSPARENT_BACKGROUND_SCREENS, screenNames } from "@/constants";
import { SolarForm } from "@/features/SolarForm";
import { useRestartForm } from "@/hooks/useRestartForm";

export const SolarFormPage = memo(() => {
  const location = useLocation();
  const navigate = useNavigate();

  const { isNoHistoryState, isFormExpired, isHardStopDetected } =
    useRestartForm();

  const checkIfNeedToRestartForm = () => {
    if (
      isNoHistoryState() ||
      isFormExpired() ||
      isHardStopDetected(screenNames.hardStop)
    ) {
      navigate("/");
    }
  };

  useEffect(() => {
    checkIfNeedToRestartForm();
    navigation("screen", {
      appName,
      currentUri: window.location.href,
    });
    return () => {};
  }, [location]);

  const useTransparentBackground = TRANSPARENT_BACKGROUND_SCREENS.some(
    (screenName) => location.pathname.includes(screenName)
  );

  return (
    <Screen
      id="solar-form"
      data-id="solar-form"
      backgroundColor={useTransparentBackground ? "transparent" : "white"}
    >
      <YupForm schema={SolarForm.schema} defaultValues={location.state?.data}>
        <Outlet />
      </YupForm>
    </Screen>
  );
});
